<template>

    <FloatingPanel>

        <div class="canvas-blocks-sky-sliderAlfa-BlockPanel">

            <Tabs :tabs="[
                'Algemeen',
                'Design',
            ]">

                <div slot="Algemeen">

                    <SwitchInput
                        name="loop"
                        label="Slider moet zichzelf herhalen"
                        :open="true"
                        :items="[
                            { value: '1', label: 'Ja' },
                            { value: '0', label: 'Nee' },
                        ]"
                        :options="options"
                        :defaultValue="'1'"
                        options-property="loop"
                    />

                </div>

                <div slot="Design">

                    <CommonInputs
                        :options="options"
                    />

                </div>

            </Tabs>

        </div>

    </FloatingPanel>

</template>

<script>

import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        SwitchInput,
        Tabs,
    },

}

</script>

<style lang="scss" scoped>

.canvas-blocks-sky-sliderAlfa-BlockPanel {

}

</style>
